module.exports = __webpack_public_path__ + "static/output-593ad4cf8d54600c1c0756e6728edecd.mp3";